"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.__tests__ = exports.Stepper = exports.getCurrentStep = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const steps_1 = __importDefault(require("antd/lib/steps"));
require("antd/lib/steps/style/index.css");
const react_resize_aware_1 = __importDefault(require("react-resize-aware"));
const Collapse_1 = require("../Collapse");
const ButtonGroup_1 = __importDefault(require("../Button/ButtonGroup"));
const Button_1 = __importStar(require("../Button"));
const Modal_1 = __importDefault(require("../Modal"));
const CheckCircle_1 = __importDefault(require("../Icons/CheckCircle"));
const Caret_1 = __importDefault(require("../Icons/Caret"));
const IconSizes_1 = require("../Icons/PropTypes/IconSizes");
const useGetGerudoContainer_1 = require("../hooks/useGetGerudoContainer");
const { Step: AntStep } = steps_1.default;
const dot = (_, { status = "wait" }) => {
    if (status === "finish" || status.indexOf("finish") !== -1) {
        return react_1.default.createElement(CheckCircle_1.default, null);
    }
    return react_1.default.createElement("div", { className: (0, classnames_1.default)("circle-icon", status) });
};
const milestoneDot = (iconDot, { status = "wait" }) => {
    if (status === "progress") {
        return dot(iconDot, { status });
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("circle-icon waiting", {
            finish: status === "finish",
        }) }));
};
const noProgressDot = () => null;
const getFirstCollapseUID = (steps) => {
    var _a;
    return (_a = steps.find((x) => x.steps && x.steps.length > 0)) === null || _a === void 0 ? void 0 : _a.uid;
};
const getCurrentStep = (steps) => {
    for (const s of steps) {
        if (s.status === "progress" || (Array.isArray(s.status) && s.status[0] === "progress")) {
            if (s.steps) {
                return (0, exports.getCurrentStep)(s.steps);
            }
            return s;
        }
    }
};
exports.getCurrentStep = getCurrentStep;
const getStepOrAccordion = (step, idx, onChange, steps, level) => {
    const key = `g-s-gerudo-stepper-${idx}`;
    const statuses = typeof step.status === "object" ? `progress-finish` : step.status;
    const classes = (0, classnames_1.default)(`status-${statuses || "wait"}`, `level-` + level, {
        "is-collapse": Boolean(step.steps),
        first: getFirstCollapseUID(steps) === step.uid,
    });
    const handleChange = (e) => {
        e.stopPropagation();
        if (step.status === "disabled")
            return;
        if (onChange)
            onChange(step, steps, e);
    };
    const status = Array.isArray(step.status) ? step.status[0] : step.status;
    // Renders one of Collapse or Step
    const stepOrAccordion = step.steps ? (react_1.default.createElement(AntStep, { className: classes, key: key, onClick: handleChange, title: react_1.default.createElement(Collapse_1.Collapse, Object.assign({ defaultActiveKey: step.status === "progress" ? step.uid : 0 }, { ghost: true }, { expandIconPosition: "left" }),
            react_1.default.createElement(Collapse_1.Panel, { key: step.uid, header: react_1.default.createElement("div", { className: (0, classnames_1.default)("label", step.uid) },
                    react_1.default.createElement("div", { className: "left" }, step.name),
                    step.suffix && react_1.default.createElement("div", { className: "right" }, step.suffix)) },
                react_1.default.createElement(steps_1.default, { direction: "vertical", progressDot: noProgressDot, current: undefined }, step.steps.map((s, i) => getStepOrAccordion(s, i, onChange, steps, level + 1))))) })) : (react_1.default.createElement(AntStep, { className: classes, key: key, onClick: handleChange, progressDot: step.type === "milestone" ? milestoneDot : dot, status: status, title: react_1.default.createElement("div", Object.assign({}, (status === "disabled"
            ? {}
            : {
                role: "button",
                tabIndex: 0,
                onKeyPress: (e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleChange(e);
                    }
                },
            }), { className: (0, classnames_1.default)("label", step.uid) }),
            react_1.default.createElement("div", { className: "left" }, step.name),
            step.suffix && react_1.default.createElement("div", { className: "right" }, step.suffix)) }));
    return stepOrAccordion;
};
const Stepper = (_a) => {
    var { after, before, className, mobileBreakpoint = 568, mobileCloseLabel, onChange, steps } = _a, props = __rest(_a, ["after", "before", "className", "mobileBreakpoint", "mobileCloseLabel", "onChange", "steps"]);
    const [resizeListener, sizes] = (0, react_resize_aware_1.default)();
    const { ref: stepperRef } = (0, useGetGerudoContainer_1.useGetGerudoContainer)();
    const mobileButtonRef = (0, react_1.useRef)(null);
    const isMobile = sizes.width && sizes.width <= mobileBreakpoint;
    const classes = (0, classnames_1.default)("gerudo-stepper", className, {
        isMobile: isMobile,
    });
    const [mobileDropdown, setMobileDropdown] = (0, react_1.useState)({ isOpen: false });
    const currentStep = (0, exports.getCurrentStep)(steps) || steps[0];
    const focusMobileButton = () => {
        setTimeout(() => {
            var _a, _b;
            (_b = (_a = mobileButtonRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[role='button']")) === null || _b === void 0 ? void 0 : _b.focus();
        }, 0);
    };
    return (react_1.default.createElement("div", Object.assign({ className: classes, ref: stepperRef }, props),
        resizeListener,
        before && react_1.default.createElement("div", { className: "before" }, before),
        isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: mobileButtonRef },
                react_1.default.createElement(steps_1.default, { direction: "vertical", progressDot: noProgressDot, current: undefined }, getStepOrAccordion(Object.assign(Object.assign({}, currentStep), { suffix: (react_1.default.createElement("span", { className: "down" },
                        react_1.default.createElement(Caret_1.default, { size: IconSizes_1.IconSizes.Large }))), status: "progress", steps: undefined }), 0, () => {
                    setMobileDropdown({ isOpen: !mobileDropdown.isOpen });
                    if (!mobileDropdown.isOpen) {
                        setTimeout(() => {
                            var _a, _b, _c;
                            if (!((_a = stepperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(":focus").length)) {
                                (_c = (_b = stepperRef.current) === null || _b === void 0 ? void 0 : _b.querySelector("[role='button']")) === null || _c === void 0 ? void 0 : _c.focus();
                            }
                        }, 0);
                    }
                    else {
                        focusMobileButton();
                    }
                }, steps, 1))),
            react_1.default.createElement(Modal_1.default, { actions: () => {
                    return (react_1.default.createElement(ButtonGroup_1.default, { align: "center" },
                        react_1.default.createElement(Button_1.default, { type: Button_1.ButtonTypes.Text, style: { width: "100%" }, onClick: () => {
                                setMobileDropdown({
                                    isOpen: !mobileDropdown.isOpen,
                                });
                                focusMobileButton();
                            } }, mobileCloseLabel || "Close")));
                }, closable: false, visible: mobileDropdown.isOpen, wrapClassName: "stepper-mobile-modal" },
                react_1.default.createElement("div", Object.assign({ className: classes, ref: stepperRef }, props), renderSteps(steps, (step, steps, evt) => {
                    setMobileDropdown({ isOpen: Boolean(step.steps) });
                    focusMobileButton();
                    onChange && onChange(step, steps, evt);
                }))))) : (react_1.default.createElement("div", { ref: mobileButtonRef }, renderSteps(steps, onChange))),
        after && react_1.default.createElement("div", { className: "after" }, after)));
};
exports.Stepper = Stepper;
const renderSteps = (steps, onChange) => {
    return (react_1.default.createElement(steps_1.default, { direction: "vertical", progressDot: noProgressDot, current: undefined }, steps.map((step, idx) => getStepOrAccordion(step, idx, onChange, steps, 1))));
};
exports.default = Stepper;
// eslint-disable-next-line no-underscore-dangle
exports.__tests__ = {
    getFirstCollapseUID,
    getCurrentStep: exports.getCurrentStep,
};
//# sourceMappingURL=index.js.map